import { ImageName } from "@mcleod/images";
import { Button, Label, Layout, Panel, Image } from "@mcleod/components";
import { Api, PermissionsUtil, StringUtil } from "@mcleod/core";
import { LMEUserSettings } from "@mcleod/general";
import { WireAdvanceQuickInfo } from "./WireAdvanceQuickInfo";

type WireCodePermissionResponse = {
    tooltip_message: string;
    enabled_driver_advances: boolean;
    visible_driver_advances: boolean;
}

export class WireUtil {

    static ENDPOINT_USER_PERMISSION_OVERRIDE_WIRECODE = "lme/dispatch/user-permission-wirecode";
    static ENDPOINT_DRIVER_ADVANCE_ICON = "lme/dispatch/validate-driver-advance-icon";
    static ENDPOINT_DRIVER_DISPATCH_MOVEMENT = "lme/dispatch/driver-dispatch-movement";

    static ENDPOINT_ELECTRONIC_ADVANCE = "lme/dispatch/ElectronicAdvances";
    static ENDPOINT_WIRECODES_USER = "lme/powerbroker/wirecodes-for-user";
    static ENDPOINT_VALIDATE_WIRECODE = "lme/powerbroker/validate-wirecode-for-advance";
    static ENDPOINT_VALIDATE_ORDER_ID = "lme/dispatch/validate-order-id";
    static ENDPOINT_VALIDATE_AMOUNT = "lme/powerbroker/validate-amount-for-advance";
    static ENDPOINT_VALIDATE_PAYEE_ID = "lme/powerbroker/validate-payee-for-advance";
    static ENDPOINT_ISSUE_ADVANCES = "lme/dispatch/issue-advance";
    static ENDPOINT_DRIVER_PAYEE_INFO = "lme/dispatch/driver-payee-info";
    static LAYOUT_PATH_AND_NAME = "lme/dispatch/ElectronicAdvances";
    static ISSUE_DRIVER_ADVANCES = "Issue driver advance";

    static disableAdvanceButton(button: Button, tooltip: string) {
        button.setProps({ tooltip: tooltip, imageName: ImageName.moneyInHand, enabled: false });
    }

    static showDeniedMessage() {
        return `You do not have permission to issue advances`;
    }

    public static slideOutTitle(isBrokerage: boolean): string {
        return isBrokerage ? "Electronic Advance" : "Driver Advance";
    }

    public static isUserDeniedAccessToLayout() : boolean {
        return PermissionsUtil.isUserDeniedLayout(WireUtil.LAYOUT_PATH_AND_NAME);
    }

    public static async validateDriverAdvanceIcon(driverId: string, driverName: string): Promise<any> {
        const endpoint = WireUtil.ENDPOINT_DRIVER_ADVANCE_ICON;
        return await Api.search(endpoint,{ "driver_one_id": driverId, "driver_one_name": driverName}).then(response => response.data[0]);
    }

    public static async userPermissionForWireCode(checkLimits?: boolean): Promise<WireCodePermissionResponse> {
        return await Api.search(WireUtil.ENDPOINT_USER_PERMISSION_OVERRIDE_WIRECODE, { "check_limits": checkLimits }).then(response => response.data[0]);
    }

    public static async driverOrderAndMovements(driverCode: string): Promise<any> {
        return await Api.search(WireUtil.ENDPOINT_DRIVER_DISPATCH_MOVEMENT, { "driver_id": driverCode }).then(response => response.data[0]);
    }

    public static async getManifestIdbyMovementId(movementId: string): Promise<any> {
        const response = await Api.post("lme/dispatch/get-movement-manifest", { "movement_id": movementId });
        return response.data[0]?.manifest_id;
    }

    public static async driverPayeeInfo(driverCode: string): Promise<any> {
        return await Api.search(WireUtil.ENDPOINT_DRIVER_PAYEE_INFO, {"driver_id": driverCode}).then(response => response.data[0]);
    }

    public static async showWireCode(movementId: string, wireCode: string, payeeId: string) : Promise<any> {
        const endpoint = "lme/dispatch/show-wire-code-advance";
        return await Api.search(endpoint, {"movement_id": movementId, "wire_code": wireCode, "payee_id": payeeId})
            .then(response => response.data[0]);
    }

    public static fullName(first: string, last: string): string {
        return !StringUtil.isEmptyString(first) ? `${first} ${last}` : `${last}`;
    }

    public static setDetailHoverToDiscover(button: Button, orderId: any, driverId: any, lastSevenDaysByPayee: boolean, historyFrom: string, movementId: string, image?: Image) {
        const component = historyFrom === "Movement" ? image : button;
        component.tooltipDynamicContent = async () => {
            if (component.tooltip == "Issue Driver Advance") {
                const layout = await Layout.getLoadedLayout("lme/dispatch/WireAdvanceQuickInfo", { minWidth: 425, minHeight: 150}) as WireAdvanceQuickInfo;
                const response = await layout.mainDataSource.search({
                        "order_id": orderId,
                        "driver_id": driverId ,
                        "last_seven_days": lastSevenDaysByPayee,
                        "history_from": historyFrom,
                        "movement_id": movementId
                    }
                );
                if (response.modelRows.length > 0) {
                    const panelHistoryOrder = layout.findComponentById("panelHistoryByOrder") as Panel;
                    const labelByPayee = layout.findComponentById("labelLast7DaystoPayee") as Label;
                    if ("Movement" === historyFrom) {
                        labelByPayee.text = "Advance History";
                    }
                    panelHistoryOrder.visible = false;
                    return layout;
                }
                return "Issue Driver Advance";
            }
        };
    }

}
